// API Configuration
// Using relative paths since we have proxy configuration in package.json
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

export const API_ENDPOINTS = {
  BASE: API_BASE_URL,
  AGENCY: {
    TEAM_MEMBERS: `${API_BASE_URL}/api/agency/team-members`,
    CLIENTS: `${API_BASE_URL}/api/agency/clients`,
    STATS: `${API_BASE_URL}/api/agency/stats`,
  },
  ADMIN: {
    DASHBOARD: `${API_BASE_URL}/api/admin/dashboard/stats`,
    USERS: `${API_BASE_URL}/api/admin/users`,
  },
  MOCKUP: {
    GENERATE: `${API_BASE_URL}/api/mockup/generate`,
    DOWNLOAD: `${API_BASE_URL}/api/download`,
  }
};

export default API_ENDPOINTS;